import { useEffect, useState } from 'react';
import { laboratoryClient } from '../utils/laboratoryClient';
import { IS_ACTIVE, PARAMETERS, STATUS, TX0120_GROUP_PARAMETER_KEY, TX0120_GROUP_PARAMETER_OPTIONS, TX0120_TREATMENT_KEY } from '../constants/experimentKeys';
import { TRIAL } from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import { CMS_HUB_PROFESSIONAL, MARKETING_HUB_PROFESSIONAL, OPERATIONS_HUB_PROFESSIONAL, SALES_HUB_PROFESSIONAL, SERVICE_HUB_PROFESSIONAL } from 'self-service-api/constants/ApiNames';
// write a type predicate that takes in an argument of type ApiName and returns true if it is a ProApiName
const ProApiNames = [MARKETING_HUB_PROFESSIONAL, CMS_HUB_PROFESSIONAL, SALES_HUB_PROFESSIONAL, SERVICE_HUB_PROFESSIONAL, OPERATIONS_HUB_PROFESSIONAL];

const isProApiName = apiName => {
  if (typeof apiName === 'number') {
    return false;
  }

  return ProApiNames.includes(apiName);
};

export const logTX0120Exposure = () => {
  laboratoryClient.logExposure(TX0120_TREATMENT_KEY);
};
export const useIsTX0120Variant = (apiName, purchaseMotion) => {
  const [isTX0120Variant, setIsTX0120Variant] = useState(false);
  const [isTX0120Fetched, setIsTX0120Fetched] = useState(false);
  const [isEligibleForTX0120, setIsEligibleForTX0120] = useState(false);
  useEffect(() => {
    if (!isTX0120Fetched) {
      if (isProApiName(apiName) && purchaseMotion === TRIAL) {
        setIsEligibleForTX0120(true);
        laboratoryClient.resolve(treatments => {
          setIsTX0120Fetched(true);

          if (Object.keys(treatments).length) {
            const treatment = treatments[TX0120_TREATMENT_KEY];
            const cohort = treatment[PARAMETERS][TX0120_GROUP_PARAMETER_KEY];
            const isActive = treatment[STATUS][IS_ACTIVE];
            const isVariant = cohort === TX0120_GROUP_PARAMETER_OPTIONS.variant && isActive;
            setIsTX0120Variant(isVariant);
          }
        });
      } else {
        setIsTX0120Variant(false);
        setIsTX0120Fetched(true);
        setIsEligibleForTX0120(false);
      }
    }
  }, [apiName, purchaseMotion, isTX0120Fetched]);
  return {
    isTX0120Variant,
    isTX0120Fetched,
    isEligibleForTX0120
  };
};